<!--<ng-container *ngIf="isProd; else tables">
  <div class="c-pricing-tables" style="display: grid; place-items: center; grid-template-columns: auto;">
    <red-alert-box
      class="t-alert-warn u-margin-vertical-large"
      [icon]="['fas', 'star']"
      size="large"
      title="Aviso"
      body="A compra de créditos avulsos está indisponível nesse momento em função
          de ajustes no sistema de pagamento. Voltamos em alguns dias!">
    </red-alert-box>
  </div>
</ng-container>-->

<ng-container *ngTemplateOutlet="tables"></ng-container>

<ng-template #tables>
  <ng-container *ngIf="(packages$ | async) as packages">

    <red-payment-table
      class="c-pricing-tables t-alert-danger"
      (packageAction)="getActivePackage($event)"
      (couponApplied)="applyCoupon($event)"
      [packages]="packages">
    </red-payment-table>


    <div class="c-pricing__obs">
      <h4 class="c-pricing__obs-title">* Plano Nota 1000</h4>

      <ul class="c-pricing__obs-list">
        <li>
          Durante o período do plano (12 meses), você terá direito a utilizar até
          duas correções por mês. Correções eventualmente não utilizadas não
          poderão ser acumuladas para o período (mês) seguinte.
        </li>
        <li>
          Permitido o cancelamento somente dentro de 7 dias, conforme lei
          do consumidor, exceto se iniciado o uso do plano. Após esse prazo,
          o cancelamento implicará em multa de 30% sobre o restante das parcelas
          não vencidas.
        </li>
      </ul>
    </div>


    <div class="c-pricing__boxes">

      <h3 class="c-pricing__boxes-title">
        Todos os pacotes incluem:
      </h3>

      <div class="c-pricing__boxes-item">
        <fa-icon class="u-icon u-icon-large u-margin-bottom-small"
                 [icon]="['fas', 'chalkboard-teacher']">
        </fa-icon>

        <p>
          Avaliação completa com nota total e nota por competência
        </p>
      </div>

      <div class="c-pricing__boxes-item">
        <fa-icon class="u-icon u-icon-large u-margin-bottom-small"
                 [icon]="['fas', 'chalkboard-teacher']">
        </fa-icon>

        <p>
          Comentários e apontamentos no texto da redação
        </p>
      </div>

      <div class="c-pricing__boxes-item">
        <fa-icon class="u-icon u-icon-large u-margin-bottom-small"
                 [icon]="['fas', 'chalkboard-teacher']">
        </fa-icon>

        <p>Sugestões de melhoria por competência</p>
      </div>

      <div class="c-pricing__boxes-item">
        <fa-icon class="u-icon u-icon-large u-margin-bottom-small"
                 [icon]="['fas', 'chalkboard-teacher']">
        </fa-icon>

        <p>Modalidades ENEM, FUVEST ou UNICAMP</p>
      </div>

      <div class="c-pricing__boxes-item">
        <fa-icon class="u-icon u-icon-large u-margin-bottom-small"
                 [icon]="['fas', 'chalkboard-teacher']">
        </fa-icon>

        <p>Mais de 200 temas disponíveis!</p>
      </div>

      <div class="c-pricing__boxes-item">
        <fa-icon class="u-icon u-icon-large u-margin-bottom-small"
                 [icon]="['fas', 'chalkboard-teacher']">
        </fa-icon>

        <p>Os melhores e mais experientes professores corretores do Brasil</p>
      </div>

      <div class="c-pricing__boxes-item c-pricing__boxes-item--bigger">
        <fa-icon class="u-icon u-icon-large u-margin-bottom-small"
                 [icon]="['fas', 'chalkboard-teacher']">
        </fa-icon>

        <p>O prazo de correção é de até 7 dias úteis.</p>
      </div>

      <div class="c-pricing__terms-link">
        <a [routerLink]="['/home/termos-de-uso']">
          <fa-icon class="u-icon"
                   [icon]="['fas', 'file-signature']">
          </fa-icon>

          Veja os termos de uso
        </a>
      </div>
    </div>
  </ng-container>
</ng-template>
